import { render } from "./DrawerComponent.vue?vue&type=template&id=2745e137"
import script from "./DrawerComponent.vue?vue&type=script&lang=js"
export * from "./DrawerComponent.vue?vue&type=script&lang=js"

import "./DrawerComponent.vue?vue&type=style&index=0&id=2745e137&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__